import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsFieldtypesService } from './edit-dialogs-fieldtypes.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-dialogs-fieldtypes',
  templateUrl: './edit-dialogs-fieldtypes.component.html',
  styleUrls: ['./edit-dialogs-fieldtypes.component.scss']
})
export class EditDialogsFieldtypesComponent implements OnInit {

  /** Subscripción para el guardado de un parametro */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsFieldtypesService: EditDialogsFieldtypesService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsFieldtypesComponent>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsFieldtypesService.build(); }

  ngOnInit() {
    this.editDialogsFieldtypesService.init(this.data).subscribe(result => {
      this.loading = false;
    });
  }

  /**
  * @description
  * Guardar el Fieldtype
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsFieldtypesService.guardar().subscribe(value => {
      console.log(value);
      // -2: El número del fieldtype está ausente
      // -1: El número del fieldtype ya existe
      // false: Error al guardar
      if (value === -1 || value === false || value === -2) {
        this.errorFieldTypes('WARNINGS.error_nuevo');
      }
      this.loading = false;
    }, error => {
      console.log(error);
      this.errorFieldTypes('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog fieldtypes
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let fieldtype = this.editDialogsFieldtypesService.fieldtypes;
    let original = this.editDialogsFieldtypesService.originalFieldtypes;
    return this.editDialogsFieldtypesService.compare(fieldtype, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorFieldTypes(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

}
